import React, { FC } from 'react'
import { useReportCardCancellationModalContext } from '../ReportCardCancellationModalContext'
import { Button, Text } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../utils/responsive'
import { useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['account']

export const Decline: FC = () => {
  const { textSize } = useConsumerSizes()
  const { t } = useTranslation(I18N_NAMESPACE)
  const { closeModal } = useReportCardCancellationModalContext()
  return (
    <>
      <Text size={textSize}>{t('account:tab:payment-methods:reportCardCancellationModal:body:decline')}</Text>
      <div className='mt-6'>
        <Button padding='Fluid' onClick={closeModal}>
          {t('account:tab:payment-methods:reportCardCancellationModal:cta:decline')}
        </Button>
      </div>
    </>
  )
}
